export default __webpack_public_path__ + "static/media/05_Herenstraat_3-huidige en nieuwe situatie.3d289b31.jpg";